import styled from "@emotion/styled"
import type { RoomBranding } from "../../../recoil/atoms/room/types"

export interface StylesProps {
  roomStyles?: RoomBranding
}

export const Wrapper = styled.div`
  display: flex;
  position: relative;
  width: 100%;
`
export const ErrorTextContainer = styled.div<StylesProps>`
  position: absolute;
  right: 0px;
  top: -17px;
  font-size: 0.7rem;
  color: ${({ roomStyles }) =>
    roomStyles?.servicePanelElementWarningText ?? "red"};
`
